import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IToastState} from '@shared/store/toast/toast-reducer';
import {TranslationStatus} from '../../../models/translation.constants';
import {TranslationService} from '../../../services/translation.service';
import {getNotification} from '@shared/store/toast/toast-selectors';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-translation-status-cell-viewer',
  templateUrl: './translation-status-cell-viewer.component.html',
  styleUrls: ['./translation-status-cell-viewer.component.scss']
})
export class TranslationStatusCellViewerComponent implements OnInit, CellComponent, OnChanges, OnDestroy {
  fieldDefinition: any;
  item: any;
  unSubscribe$ = new Subject<void>();
  translationId = '';
  status = '';
  private notifications: any;

  constructor(private toastStore: Store<IToastState>) {
  }

  ngOnInit() {
    let isInitiated = false;
    this.translationId = this.item.id;
    this.notifications = this.toastStore.pipe(select(getNotification, this.translationId), takeUntil(this.unSubscribe$));
    this.notifications.subscribe(notification => {
    if (isInitiated && notification && notification.payload && this.item && this.item.id === notification.payload.id && this.item.cells && this.item.cells['Status'] && notification.payload.id === this.translationId && notification.payload.fieldValues) {
      this.item.cells['Status'].displayText = notification.payload.fieldValues['Status'];
      this.item.cells['StatusTitle'].displayText = '';
    }
    });
    if (this.item && this.item.cells && this.item.cells['Status']) {
      this.status = this.item.cells['Status'].displayText;
    }
    isInitiated = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy() {
    this.item.cells['Status'] = null;
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}

